module.exports = __webpack_public_path__ + "static/media/print1.e2646458.jpg";